/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { InputPromotionCodeActivity } from 'apollo/types';

const activityMapper = (formValues: any) => {
  const activities: InputPromotionCodeActivity[] = [];
  let counter = 1;

  Object.keys(formValues).forEach((key) => {
    if (key.includes('activity')) {
      const activityId = key.split('_')[2];
      const prop = key.split('_')[0];

      let maxQuantity = 0;
      let percentageDiscount = 0;

      let edited = false;

      if (prop === 'discountPercentage' && counter % 2 !== 0) {
        if (formValues[key] !== undefined) {
          edited = true;
          percentageDiscount = formValues[key] as number;
        } else {
          percentageDiscount = 0;
        }

        activities.push({
          activityId,
          maxQuantity,
          percentageDiscount,
          edited,
        });
        counter += 1;
      } else if (prop === 'maxTickets' && counter % 2 === 0) {
        if (formValues[key] !== undefined) {
          edited = true;
          maxQuantity = formValues[key] as number;
        } else {
          maxQuantity = 0;
        }
        activities.forEach((activity, index) => {
          if (activity.activityId === activityId) {
            activities[index] = {
              activityId,
              maxQuantity,
              percentageDiscount: activities[index].percentageDiscount,
              edited,
            };
            counter = 1;
          }
        });
      }
    }
  });

  return { activities };
};

export default activityMapper;
